import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Checkbox } from "@tql/ui-components-react/tql/inputs/beta";

import { useUpdateRoutingGuide } from "~/features/routing-guide/hooks/use-update-routing-guide.ts";
import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { RoutingGuideType } from "~/shared/schemas/routing-guide-schema.ts";

type ActiveCellProps = GridCustomCellProps & {
	isCustomerLayout?: boolean;
	canEdit?: boolean;
	testId?: string;
};

export const RoutingGuideActiveCell = (props: ActiveCellProps) => {
	const dataItem = props.dataItem as RoutingGuideType;
	const { updateRoutingGuide } = useUpdateRoutingGuide();

	const isExclusionToggle =
		props.isCustomerLayout === true && !dataItem.customerId;

	const checked = isExclusionToggle
		? !dataItem.isExcluded
		: !!dataItem.isActive;

	const handleChange = () => {
		if (isExclusionToggle) return;
		const nextIsActive = !dataItem.isActive;
		updateRoutingGuide({
			id: dataItem.id,
			name: dataItem.name,
			rules: dataItem.rules,
			carrier: dataItem.carrier,
			isAutoSelected: dataItem.isAutoSelected,
			selectionMethod: dataItem.selectionMethod,
			isActive: nextIsActive,
			isGlobal: dataItem.customerId == null,
			customerId: dataItem.customerId,
		});
	};

	return (
		<GridTd data-testid={props.testId} tdProps={props.tdProps}>
			<Checkbox
				aria-label={
					checked ? "Deactivate routing guide" : "Activate routing guide"
				}
				checked={checked}
				disabled={isExclusionToggle || props.canEdit === false}
				onChange={handleChange}
			/>
		</GridTd>
	);
};
